import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  padding-inline: 10px;
  padding-block: 20px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  color: ${props => props.theme.colors.text};
`;

export const Subtitle = styled.span`
  color: ${props => props.theme.colors.grey_text};
  font-weight: 700;
  font-size: 12px;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OptionTitle = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.text}; //title não existe TODO
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
